import { twMerge } from "tailwind-merge";

export enum TextVariants {
    smallBody400 = "smallBody400",
    smallBody500 = "smallBody500",
    smallBody600 = "smallBody600",
    smallBody700 = "smallBody700",
    body400 = "body400",
    body500 = "body500",
    body600 = "body600",
    body700 = "body700",
    sectionHeading500 = "sectionHeading500",
    largeSectionHeading600 = "largeSectionHeading600",
    pageHeading500 = "pageHeading500",
}

const TextVariantConfig: Record<TextVariants, { style: string; element: React.ElementType<TextProps, any> }> = {
    [TextVariants.smallBody400]: { style: "text-xs font-normal leading-4.5", element: "p" },
    [TextVariants.smallBody500]: { style: "text-xs font-medium leading-4.5", element: "p" },
    [TextVariants.smallBody600]: { style: "text-xs font-semibold leading-4.5", element: "p" },
    [TextVariants.smallBody700]: { style: "text-xs font-bold leading-4.5", element: "p" },
    [TextVariants.body400]: { style: "text-base font-normal leading-6", element: "p" },
    [TextVariants.body500]: { style: "text-base font-medium leading-6", element: "p" },
    [TextVariants.body600]: { style: "text-base font-semibold leading-6", element: "p" },
    [TextVariants.body700]: { style: "text-base font-bold leading-6", element: "p" },
    [TextVariants.sectionHeading500]: { style: "text-base font-medium leading-6", element: "h3" },
    [TextVariants.largeSectionHeading600]: { style: "text-xl font-semibold leading-7.5", element: "h2" },
    [TextVariants.pageHeading500]: { style: "text-2xl font-medium leading-9", element: "h1" },
};

type TextProps = {
    as?: React.ElementType;
    variant?: keyof typeof TextVariants;
    className?: string;
    children?: React.ReactNode;
};

const Text = ({ as, variant = "body400", children, className, ...rest }: TextProps) => {
    const { style, element } = TextVariantConfig[variant];
    const Component = as || element;
    return (
        <Component className={twMerge(style, className)} {...rest}>
            {children}
        </Component>
    );
};

export default Text;
